module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('swiper', {
    staticClass: "swiper-box",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.mapPic), function(img) {
    return _c('swiper-slide', {
      key: img,
      staticClass: "swiper-item"
    }, [_c('img', {
      attrs: {
        "src": img
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination ",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19189044"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/townMap.vue
// module id = 224
// module chunks = 1